module.exports = __webpack_public_path__ + "img/product-4.8b413542.svg";